import { ScopeOption } from '../types';

/**
 * Варианты скоупов для модулей «Остатки» и «Справочник» (коды guide.*)
 */
export const guideScopes: Record<string, ScopeOption[]> = {
  // «Остатки»: зона действует на поиск, карту, карточку аптеки и выгрузку
  'guide.remains.view': [
    { value: 'all', label: 'Вся сеть', description: 'Остатки: все аптеки сети', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Остатки: аптеки из myPharmacy оператора', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Остатки: аптеки своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'Остатки: нет доступа', badgeColor: '#ef4444' }
  ]
};
